import { createFileRoute } from '@tanstack/react-router';
import * as z from 'zod/v4';
import { zodValidator } from '@tanstack/zod-adapter';
import { parseEnv } from '@/helpers/route-utils';
import { filtersSchema } from '@/helpers/build-get-events-filter';

const searchSchema = z.object({
  search: z.string().optional(),
  groupBy: z.enum(['levels', 'playerAge']).optional(),
  groupByOrder: z.enum(['asc', 'desc']).optional(),
  filters: filtersSchema.optional(),
});

export const Route = createFileRoute('/_auth/$env/journey')({
  validateSearch: zodValidator(searchSchema),
  params: parseEnv(),
});
